module.exports = __webpack_public_path__ + "img/latestLogo.bdd0120f.png";